import ApplicationController from '../../javascript/controllers/application_controller'
import {
  recordMarketingConsent,
  marketingConsentGranted,
  marketingConsentDecision,
  decisionIsCurrent,
  POLICY_VERSION,
} from '../../javascript/lib/marketing_consent'

// Reflects the stored consent decision and lets the user grant or withdraw it
// (Art. 7(3)). Writes via the shared lib and returns early if the write fails.
// Dispatches 'marketing-consent:granted' on grant so co-rendered capture/fields
// controllers can fire without a page reload (e.g. landing via Datenschutz page).
// Also subscribes to 'marketing-consent:granted' to re-render its status indicator
// when another controller (e.g. the banner) dispatches the event.
export default class extends ApplicationController {
  static targets = ['status']

  connect() {
    this.render()
    this._onConsentChange = () => this.render()
    document.addEventListener('marketing-consent:granted', this._onConsentChange)
  }

  disconnect() {
    if (this._onConsentChange)
      document.removeEventListener('marketing-consent:granted', this._onConsentChange)
  }

  grant() {
    if (!this.write(true)) return
    document.dispatchEvent(new CustomEvent('marketing-consent:granted'))
    this.addBreadcrumb('Consent', 'marketing_granted', { version: POLICY_VERSION })
    this.render()
  }

  revoke() {
    if (!this.write(false)) return
    this.addBreadcrumb('Consent', 'marketing_revoked', { version: POLICY_VERSION })
    this.render()
  }

  write(granted) {
    if (recordMarketingConsent(granted)) return true
    this.reportError(new Error('marketing consent write failed'), {
      source: 'ad_attribution_consent_settings',
      action: granted ? 'grant' : 'revoke',
    })
    return false
  }

  render() {
    if (!this.hasStatusTarget) return
    const granted = marketingConsentGranted()
    const denied = marketingConsentDecision() === 'denied' && decisionIsCurrent()
    const key = granted ? 'statusGranted' : denied ? 'statusDenied' : 'statusUndecided'
    this.statusTarget.textContent = this.statusTarget.dataset[key] || ''
  }
}
